export const ENTRY_LOAD_RECOVERY_KEY = "krmt:entry-load-recovery-at";
export const ENTRY_LOAD_RECOVERY_WINDOW_MS = 30_000;

type RecoveryStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export interface EntryLoadRecoveryOptions {
  storage: RecoveryStorage;
  reload: () => void;
  now?: () => number;
  retryWindowMs?: number;
}

export async function loadEntryWithRecovery<T>(
  load: () => Promise<T>,
  options: EntryLoadRecoveryOptions,
): Promise<T | null> {
  try {
    const entry = await load();
    options.storage.removeItem(ENTRY_LOAD_RECOVERY_KEY);
    return entry;
  } catch (error) {
    const now = options.now?.() ?? Date.now();
    const retryWindowMs = options.retryWindowMs ?? ENTRY_LOAD_RECOVERY_WINDOW_MS;
    const previousAttempt = Number(options.storage.getItem(ENTRY_LOAD_RECOVERY_KEY));
    const alreadyRetried = Number.isFinite(previousAttempt)
      && previousAttempt > 0
      && now - previousAttempt <= retryWindowMs;

    if (alreadyRetried) {
      options.storage.removeItem(ENTRY_LOAD_RECOVERY_KEY);
      throw error;
    }

    options.storage.setItem(ENTRY_LOAD_RECOVERY_KEY, String(now));
    options.reload();
    return null;
  }
}
